import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ko from '@/locales/ko.json';
import en from '@/locales/en.json';

export default i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    resources: {
      'ko-KR': {
        translation: ko,
      },
      'en-US': {
        translation: en,
      },
    },
  });
